var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSoporBorder(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    className: "theChar",
    "data-name": "sopor",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 203.51 115.23",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    id: "f2365690-ff7a-4a7d-8f99-974bec11f88d",
    "data-name": "border",
    d: "M72.91,1.42H154V.25h35.9l11.22,12.49s2.11,7.22,2.11,10.61V69.68h-3.9v6.84h-9.55S189,80.9,188,81.87s-7.24.63-7.52,4.54-.74,12.16-1.81,13.08-16.19,13.11-19.12,14.24-39.58,2.12-41.33,0-4.1-8.77,0-12.19,6.56-5,6.71-8.85,0-11.47,0-11.47H75.1s-1.79,5-3.56,7.15-4.08,4.32-4.08,4.32,4.71,13.19,4.08,14.35-10.71,5.39-13.78,5.46c-2.69.06-29.11,2.7-31.06,1.07s-3.75-11-3.91-14.43,1.1-10.64-.51-10.93-15.78.66-16.17-.48.39-24.43,0-24.89S.52,63.38.36,59.46s-.33-25.3,1-26.31,14.05-.92,17.89-2c2.68-.75,7.3-21.46,21.29-25S72,5.43,72.11,4.38A17.8,17.8,0,0,1,72.91,1.42Z",
    style: {
      fill: "none",
      stroke: "#1d1d1b",
      strokeMiterlimit: 10,
      strokeWidth: "0.5px"
    }
  }));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSoporBorder);
export default __webpack_public_path__ + "static/media/sopor-border.f061d0fc.svg";
export { ForwardRef as ReactComponent };